import React from "react";

export function EstadoTexto(props) {
    return (
        <span className="table-demo">
            <span className={`customer-badge status-${props.estado}`}>{props.estado}</span>
        </span>
    );
}
